import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import SkinAssistantReindexButton from "./SkinAssistantReindexButton";

const LINKS = [
  { to: "/skin-assistant/rules", label: "Rules" },
  { to: "/skin-assistant/results", label: "Results" },
  { to: "/skin-assistant/leads", label: "Leads" },
  { to: "/skin-assistant/chats", label: "Chats" },
];

export default function SkinAssistantNav() {
  const { pathname } = useLocation();

  return (
    <div className="d-flex flex-column flex-lg-row align-items-stretch align-items-lg-center justify-content-between gap-2 mb-4">
      <nav className="nav nav-pills nav-fill gap-2 flex-wrap skin-assistant-nav flex-grow-1">
        {LINKS.map((link) => {
          const active = pathname === link.to || pathname.startsWith(`${link.to}/`);
          return (
            <NavLink
              key={link.to}
              to={link.to}
              className={`nav-link${active ? " active" : ""}`}
            >
              {link.label}
            </NavLink>
          );
        })}
      </nav>
      <SkinAssistantReindexButton className="flex-shrink-0 align-self-lg-center" />
    </div>
  );
}
